/**
 * Where a verification objection points, in the reader's words.
 *
 * The fact verifier is handed the report's narrative as a finite set of
 * sections (`buildFactVerificationInputSet` in workflows-api: `summary` plus
 * the three parts of `structuredSummary`) and echoes one of those ids back on
 * every objection. Naming them with the panel's OWN section labels is the
 * point: the reader is being sent to a card they can see, not to a field name.
 *
 * A verifier that invents an id outside this set falls back to the raw string
 * — visible and honest, rather than silently relabelled.
 *
 * A `Map`, not an object: the id is a free-form string produced by a model
 * that reads an untrusted transcript, and indexing an object with it reaches
 * the prototype too — `'constructor'` would hand a function to the label,
 * which the print report then stringifies into the document.
 */
export const NARRATIVE_SECTION_LABEL_KEYS: ReadonlyMap<string, string> = new Map([
  ['summary', 'records.analysisPanel.summary.title'],
  ['structuredSummary.situation', 'records.analysisPanel.structuredSummary.situation'],
  ['structuredSummary.actions', 'records.analysisPanel.structuredSummary.actions'],
  ['structuredSummary.outcome', 'records.analysisPanel.structuredSummary.outcome'],
]);
